import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRename(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h15a1 1 0 1 0 0-2H5V5h15a1 1 0 1 0 0-2H5Z"
      />
      <path
        fill="currentColor"
        d="M8 7a1 1 0 0 0 0 2h2v6H8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2V9h2a1 1 0 1 0 0-2H8Z"
      />
    </BaseIcon>
  );
}
